module.exports = __webpack_public_path__ + "static/img/about_h5bg_07_zh.ffa0c4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_h5bg_07_zh.png
// module id = woRo
// module chunks = 34